import { render, staticRenderFns } from "./InvoicesV4.vue?vue&type=template&id=f1758c22&scoped=true"
import script from "./InvoicesV4.vue?vue&type=script&lang=js"
export * from "./InvoicesV4.vue?vue&type=script&lang=js"
import style0 from "./InvoicesV4.vue?vue&type=style&index=0&id=f1758c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1758c22",
  null
  
)

export default component.exports